/**
 * Sprint C3a — Frontend auth-state types.
 *
 * `Me` ist der WIRE-Type für `GET /api/auth/me` (server-side). Bleibt
 * unverändert seit pre-C3a (id/email/displayName/role).
 *
 * `AuthedUser` ist der LOCAL-derived Type: `Me & { isAdmin: boolean }`.
 * `isAdmin` wird frontend-side aus `me.role === 'Admin'` abgeleitet —
 * NICHT als server-returned-field. Verhindert wire-contract-drift
 * (Codex R1 Architecture-1).
 *
 * Components die Auth-State konsumieren nehmen `AuthedUser` als prop,
 * nicht `Me`. Existing pages (Layout/Sidebar/Pages) wurden in Sprint C3a
 * von `user: Me` auf `user: AuthedUser` migriert.
 */
export interface Me {
  id: string;
  email: string;
  displayName: string;
  role: string;
  /** true wenn ein admin-gesetztes Temp-Passwort noch geändert werden muss.
   *  Gated in App.tsx → Forced-Change-Screen statt App-Zugriff. Optional für
   *  Vorwärtskompatibilität mit älteren /me-Responses (default false). */
  mustChangePassword?: boolean;
  /** First-Run-Onboarding: ISO-Timestamp wenn die Tour abgeschlossen/übersprungen
   *  wurde, sonst null/undefined → Auto-Trigger der Orientierungs-Tour.
   *  Optional für Vorwärtskompatibilität mit älteren /me-Responses. */
  onboardedAt?: string | null;
}

export type AuthedUser = Me & {
  /** Computed from `role === 'Admin'`. */
  isAdmin: boolean;
};

export function deriveAuthedUser(me: Me): AuthedUser {
  return { ...me, isAdmin: me.role === 'Admin' };
}
